
import { mapActions } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'
import { parseProductGiftCard } from '~/helpers/shopify/product'
import LolePicture from '~/components/picture/lole-picture'
import Price from '~/components/price/price'
import Button from '~/components/buttons/Button'
import generateHeader from '~/helpers/header'

export default {
  components: {
    LolePicture,
    Price,
    Button,
  },
  async asyncData({
    error,
    app: { $storyblok, $sentryException, $shopify, $gtm, i18n },
    store: {
      state: {
        currency: { currency },
      },
    },
  }) {
    let wordingAccount = null
    let wording = null
    let giftCard = null
    // GTM
    try {
      $gtm.push({
        ecommerce: undefined,
        product: undefined,
        search: undefined,
      })
      $gtm.push({ 'page.type': 'gift card' })
    } catch (e) {
      $sentryException(e, {
        source: 'GTM page gift card',
        level: 'warning',
        extra: 'GTM page gift card failed',
      })
    }
    // STORYBLOK
    try {
      const lang = i18n?.locale.split('-')?.[0]
      const { stories } = await $storyblok.getStories(
        `by_slugs=${lang}/pages/account/account_giftCard,${lang}/pages/product-page/gift_card`
      )
      wordingAccount = stories.find(
        (s) => s.name === 'account_giftCard'
      ).content
      wording = stories.find((s) => s.name === 'gift_card').content
    } catch (e) {
      $sentryException(e, {
        source: 'storyblok',
        level: 'warning',
        extra: 'Call storyblok gift-card failed',
      })
      error({
        statusCode: 500,
        message: 'Call storyblok gift-card failed',
      })
    }
    // SHOPIFY GIFT CARD PRODUCT + PARSING
    try {
      const { data } = await $shopify.product.retrieveGiftCardProduct(currency)
      giftCard = parseProductGiftCard(data.product, {})
    } catch (e) {
      $sentryException(e, {
        source: 'storyblok',
        level: 'warning',
        extra: 'Call to shopify for giftcards failed',
      })
      error({
        statusCode: 500,
        message: 'Call to shopify for giftcards failed',
      })
    }
    return {
      wordingAccount,
      wording,
      giftCard,
    }
  },
  data: () => ({
    selectedGiftCard: {
      id: null,
      title: null,
      barcode: null,
      price: null,
    },
    cardNumber: '',
    submitted: false,
    loading: false,
    errors: [],
    result: null,
    giftCard: null,
  }),
  head() {
    if (!this.wording.SEO) return
    this.wording.SEO.og_image = this.wording.SEO.og_image
      ? this.wording.SEO.og_image
      : this.$config.DEFAULT_OG_IMAGE
    return generateHeader({
      ...this.wording.SEO,
      path: this.$route.path,
    })
  },
  validations: {
    cardNumber: {
      required,
      maxLength: maxLength(20),
    },
  },
  mounted() {
    if (
      this.giftCard &&
      this.giftCard.variants &&
      this.giftCard.variants.length > 0
    )
      this.selectedGiftCard = this.giftCard.variants[0]
  },
  methods: {
    ...mapActions({
      vxAddProductsToCart: 'product/addProductsToCart',
    }),
    addToCart() {
      this.vxAddProductsToCart({
        products: [
          {
            product: {
              id: this.selectedGiftCard.id,
              title: this.giftCard.title,
              internal_type: 'gift-card',
              internal_color_code: 'gift-card',
              normalized_color: 'gift-card',
              categories: ['gift-card'],
              price: this.selectedGiftCard.price.amount,
              strikeout_price: null,
              currency: this.selectedGiftCard?.price?.currencyCode,
              medias: this.giftCard.medias,
              handle: this.giftCard.handle,
            },
            variant: {
              size_name: this.selectedGiftCard.title,
              id: this.selectedGiftCard.id,
              barcode: this.selectedGiftCard.barcode,
              quantity: 1,
            },
          },
        ],
        location: 'gift-card-page',
      })
    },
    async checkBalance() {
      this.result = null
      this.$v.$touch()
      this.submitted = true
      this.loading = true
      this.errors = []
      if (!this.$v.$invalid) {
        try {
          const { data } = await this.$axios.post(
            '/api/shopify/getAmountGiftCard',
            {
              locale: this.$i18n.locale,
              cardNumber: this.cardNumber.trim(),
            }
          )
          if (data === 'card not found') {
            this.errors.push('CARD_ERROR_NOT_FOUND')
          } else this.result = { balance: data?.balance }
        } catch (e) {
          this.errors.push('CARD_ERROR_CATCHED')
          this.$sentryException(e, {
            source: '/account/gift-card.vue',
            level: 'fatal',
            extra: `Call gift-card failed: ${e}`,
          })
          this.loading = false
        }
      }
      this.loading = false
    },
  },
}
